import React from "react";
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";

import * as actions from "../../../state/actions/cookiebox";
import { getCookiebox } from "../../../state/reducers/cookiebox";
import LanguageContext from "../../../state/context/LanguageContext";

const ManageCookie = ({ cookiebox = true, closeCookiebox, showCookiebox }) => {
  return (
    <LanguageContext.Consumer>
      {({ language, translation }) => (
        <section 
          className="block-manage-cookies my-5"
          role="region"
          aria-labelledby="cookies"
          aria-label="Gérer les cookies"
        >
          <Row>
            <Col>
              <h3 id="cookies">{translation?.cookieManageTitle || 'Gérer les cookies'}</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <div 
                className="manage-cookies-option mb-4"
                role="group"
                aria-label="Préférences de cookies"
                aria-describedby="cookie-description"
              >
                <label 
                  className="switch"
                  htmlFor="cookie-switch"
                >
                  <span className="switch-text" id="cookie-switch-label">Cookies</span>
                  <input
                    id="cookie-switch"
                    type="checkbox"
                    role="switch"
                    checked={cookiebox === false && cookiebox !== 'refused'}
                    onChange={() => {
                      if (cookiebox !== true) {
                        showCookiebox();
                      } else {
                        closeCookiebox();
                      }
                    }}
                    aria-labelledby="cookie-switch-label"
                    aria-describedby="cookie-description"
                    aria-checked={cookiebox === false && cookiebox !== 'refused'}
                  />
                  <span className="slider round" aria-hidden="true"></span>
                </label>
              </div>
              <p className="m-0" id="cookie-description">
                {translation?.cookieManageText || 'Vous pouvez gérer vos préférences de cookies ici.'}
              </p>
            </Col>
          </Row>
        </section>
      )}
    </LanguageContext.Consumer>
  );
};

const mapStateToProps = state => ({
  cookiebox: getCookiebox(state)
});

export default connect(
  mapStateToProps,
  actions
)(ManageCookie);
